// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetEventListModel from '../../model/widget-event-list-model';
import WidgetEventListDTO from '../dto/widget-event-list-dto';
import dtoSchema from '../schemas/widget-event-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import EventOccurenceModel from '../../model/event-occurence-model';

export default abstract class WidgetEventListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetEventListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.name = data.name ?? undefined;
      this.abbreviation = data.abbreviation ?? undefined;
      this.startDate = data.startDate ?? undefined;
      this.endDate = data.endDate ?? undefined;
      this.city = data.city ?? undefined;
      this.eventArea = data.eventArea ?? undefined;
      this.imageUrl = data.imageUrl ?? undefined;
      this.imageThumbUrl = data.imageThumbUrl ?? undefined;
      this.price = data.price ?? undefined;
      this.registrationStatus = data.registrationStatus ?? undefined;
      this.registrationIndicator = data.registrationIndicator ?? undefined;
      this.isOnlineRegistrationActive = data.isOnlineRegistrationActive;
      this.detailUrl = data.detailUrl ?? undefined;
      this.useEventLinkAsDetailPage = data.useEventLinkAsDetailPage;
      this.eventType = data.eventType ?? undefined;
      this.registrationFormUrl = data.registrationFormUrl ?? undefined;
      this.occurences = data.occurences?.map((i) => EventOccurenceModel.toModel(i)) ?? [];
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  name?: string;
  /**
  */
  abbreviation?: string;
  /**
  * @type {date-time}
  */
  startDate?: string;
  /**
  * @type {date-time}
  */
  endDate?: string;
  /**
  */
  city?: string;
  /**
  */
  eventArea?: string;
  /**
  */
  imageUrl?: string;
  /**
  */
  imageThumbUrl?: string;
  /**
  * @type {double}
  */
  price?: number;
  /**
  */
  registrationStatus?: string;
  /**
  */
  registrationIndicator?: string;
  /**
  */
  isOnlineRegistrationActive?: boolean;
  /**
  */
  detailUrl?: string;
  /**
  */
  useEventLinkAsDetailPage?: boolean;
  /**
  * @type {int64}
  */
  eventType?: number;
  /**
  */
  registrationFormUrl?: string;
  /**
  */
  occurences?: EventOccurenceModel[];

  static toModel(dto: DeepPartial<WidgetEventListDTO>): WidgetEventListModel;
  static toModel(dto: DeepPartial<WidgetEventListDTO> | undefined | null): WidgetEventListModel | undefined;
  static toModel(dto: DeepPartial<WidgetEventListDTO> | undefined | null): WidgetEventListModel | undefined {
    return dto ? new WidgetEventListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetEventListModel> | WidgetEventListModel): WidgetEventListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      name: unwrapped.name,
      abbreviation: unwrapped.abbreviation,
      startDate: unwrapped.startDate,
      endDate: unwrapped.endDate,
      city: unwrapped.city,
      eventArea: unwrapped.eventArea,
      imageUrl: unwrapped.imageUrl,
      imageThumbUrl: unwrapped.imageThumbUrl,
      price: unwrapped.price,
      registrationStatus: unwrapped.registrationStatus,
      registrationIndicator: unwrapped.registrationIndicator,
      isOnlineRegistrationActive: unwrapped.isOnlineRegistrationActive,
      detailUrl: unwrapped.detailUrl,
      useEventLinkAsDetailPage: unwrapped.useEventLinkAsDetailPage,
      eventType: unwrapped.eventType,
      registrationFormUrl: unwrapped.registrationFormUrl,
      occurences: unwrapped.occurences,
    } as WidgetEventListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetEventListModel, can not map to WidgetEventListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
